/* eslint-disable no-underscore-dangle */
/**
 * Shows a hover box
 *
 * by default it will close on any click on the screen
 *
 * @param content {string}
 * @param buttonContent {string}
 * @param hiddenTabletUp {boolean} this specifies if its to be hidden for sizes greater than mobile
 * @param closeOnScroll {boolean} closes when use scrolls on desktop or tablet
 * @param callToAction {function} code to be excecuted when the button is clicked
 * @constructor
 */
function HoverBox(content, buttonContent, hiddenTabletUp, closeOnScroll, callToAction) {

  const tempElemnt = document.createElement('DIV');
  tempElemnt.innerHTML =
    `<div data-component='hover-box' class="${hiddenTabletUp ? 'hidden-tablet-up' : ''}">
         ${content}
         <button class="call-to-action">${buttonContent}</button>
       </div>`;

  this._element = tempElemnt.firstChild;
  this._destroyBoundWithThis = this.destroy.bind(this);
  this._destroyOnScrollBoundWithThis = this.destroyOnScroll.bind(this);
  this._closeOnScroll = closeOnScroll;
  this._callToAction = callToAction;
  this._notScrolledYet = true;
}

HoverBox.prototype = {

  /**
   * Shows the element and adds listeners
   */
  show() {
    document.body.appendChild(this._element);
    this.addListeners();
  },

  /**
   * Sets up the various listeners depending on the properties
   */
  addListeners() {
    document.querySelector('.call-to-action').addEventListener('click', this._callToAction);
    document.addEventListener('click', this._destroyBoundWithThis);
    if (this._closeOnScroll) {
      document.addEventListener('scroll', this._destroyOnScrollBoundWithThis);
    }
  },

  destroy() {
    this._element.parentElement.removeChild(this._element);
    document.removeEventListener('click', this._destroyBoundWithThis);
  },
  destroyOnScroll() {
    if (this._closeOnScroll && !this._notScrolledYet) { // some kind of strange debounce mechanism, true only on second scroll event
      document.removeEventListener('scroll', this._destroyOnScrollBoundWithThis);
      this._element.parentElement.removeChild(this._element);
    }
    this._notScrolledYet = false;
  }
};

module.exports = HoverBox;
